import React, { useEffect } from 'react'
import { Button, Card } from '@material-ui/core'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { selectTeamsSupported, selectUserTeam } from '../../../redux/selectors/userTeamSelectors'
import PanelHeader from '../../common/PanelHeader'
import { rootRoute } from '../../../routes/routes'
import { formatUrl } from '../../../util/formatUtils'
import {
  publishClickedButtonInPanelTeams,
  publishViewedPanelTeams,
} from '../../../util/events/teamsProfileEventPublishers'
import { ACTION_TARGETS } from '../../../util/events/teamsEvents'
import MyTeam from './MyTeam'

const PanelTeams = ({ userTeam, isTeamsSupported }) => {
  useEffect(() => {
    if (isTeamsSupported) {
      publishViewedPanelTeams(userTeam.team?.name)
    }
  }, [isTeamsSupported, userTeam])

  if (!isTeamsSupported) {
    return null
  }

  return (
    <Card>
      <PanelHeader title="My Team" />
      {userTeam.team && <MyTeam />}
      {!userTeam.team && (
        <Button
          component={Link}
          to={formatUrl(rootRoute.path, {}, [{ key: 'createTeam', value: 'true' }])}
          onClick={() => publishClickedButtonInPanelTeams(ACTION_TARGETS.JOIN_OR_CREATE)}
          color="primary"
        >
          + Create or join a team
        </Button>
      )}
    </Card>
  )
}

const mapStateToProps = state => {
  const userTeam = selectUserTeam(state)
  const isTeamsSupported = selectTeamsSupported(state)

  return {
    userTeam,
    isTeamsSupported,
  }
}

export default connect(mapStateToProps)(PanelTeams)
